<template>
  <div class="navigation side-margin">
    <a class="navigation__logo" href="/">
      <img src="../src/assets/logo.svg">
    </a>
    <input type="checkbox" class="navigation__checkbox" id="navi-toggle" v-model="navToggle">
    <label for="navi-toggle" class="navigation__button">
        <span class="navigation__icon"></span>
    </label>
    <div class="navigation__background">&nbsp;</div>
    <nav class="navigation__nav">
        <ul class="navigation__list">
            <li class="navigation__item"><router-link to="/" class="navigation__link" @click="CloseNavigation">Home</router-link></li>
            <li class="navigation__item"><router-link to="/tables" class="navigation__link" @click="CloseNavigation">Tables</router-link></li>
            <!--li class="navigation__item"><router-link to="/comingsoon" class="navigation__link" @click="CloseNavigation">Power</router-link></li-->
            <li class="navigation__item"><router-link to="/comingsoon" class="navigation__link" @click="CloseNavigation">Charts</router-link></li>
            <li class="navigation__item"><router-link to="" class="navigation__link anti-vanish" id="mobile-login" @click="CloseNavigation_Login">Log in</router-link></li>
        </ul>
    </nav>
    <a href="#" class="button button--small" id="btn_login" @click="login">Log in</a>
    <div class="navigation__user" id="nav-user">
      <ul class="navigation__balance">
          <li><img src="../src/assets/credit.png" class="navigation__currency"><span id="nav-balance-credits"></span></li>
          <li><img src="../src/assets/dec.png" class="navigation__currency"><span id="nav-balance-dec"></span></li>
          <li><img src="../src/assets/sps.png" class="navigation__currency"><span id="nav-balance-sps"></span></li>
      </ul>
      <div class="navigation__username" id="nav-username"></div>
    </div>
  </div>
  <router-view/>
</template>

<script>
import { set_store, on_load, login } from './js/lib.js'

export default {
  name: 'App',
  data () {
    return {
      navToggle: false
    }
  },
  beforeCreate() {
    set_store(this.$store);
    on_load();
  },
  methods: {
    CloseNavigation () {
      this.navToggle = false;
    },
    login() {
      login();
    },
    CloseNavigation_Login() {
      this.navToggle = false;
      login();
    }
  }
}
</script>
